import { downloadBase64File } from '@/shared/utils/downloadfile'
import { BaseButton } from '../BaseButton/BaseButton'
import { BaseDialog } from '../BaseDialog/BaseDialog'

type Props = {
  modalVisible: boolean
  setModalVisible: (value: boolean) => void
  receiptFile: string | null
  receiptType: string | null
}

export const FileModal = ({ modalVisible, setModalVisible, receiptFile, receiptType }: Props) => {
  const dataUrl = `data:${receiptType};base64,${receiptFile}`
  const isImage = receiptType?.startsWith('image/')
  const isPdf = receiptType === 'application/pdf'
  const filename = `receipt.${receiptType?.split('/')[1] ?? 'bin'}`

  const handleDownload = () => {
    if (!receiptFile || !receiptType) return

    downloadBase64File({
      base64: receiptFile,
      mimeType: receiptType,
      filename: filename,
    })
  }

  return (
    <BaseDialog
      isVisible={modalVisible}
      onAction={() => {
        setModalVisible(false)
      }}
      onClose={() => setModalVisible(false)}
      actionButtonName="Готово"
      xButton={false}
      closeButton={false}
    >
      <div className="p-4 max-h-[70vh] overflow-auto custom-scrollbar">
        {isImage ? (
          <img src={dataUrl} alt={filename} className="max-w-full h-auto" />
        ) : isPdf ? (
          <iframe src={dataUrl} className="w-full h-[60vh]" title={filename} />
        ) : (
          <div className="py-8 text-center">
            <p className="mb-4 text-text-secondary">
              Предварительный просмотр недоступен для данного типа файла
            </p>
            <BaseButton
              variant="transparent"
              padding="xs"
              className="disabled:opacity-50 text-primary hover:text-primary-hover dark:hover:text-primary-dark-hover dark:text-primary-dark"
              onClick={handleDownload}
            >
              Скачать файл
            </BaseButton>
          </div>
        )}
      </div>
    </BaseDialog>
  )
}
